module.exports = __webpack_public_path__ + "img/tc-100x140.7af88f79.jpg";